export const NODE_VARIANTS = {
  primary: {
    background: 'var(--color-primary-600)',
    color: 'var(--color-contrast-primary-600)',
    borderColor: 'var(--color-primary-700)',
    selectedBorderColor: 'var(--color-primary-800)'
  },
  secondary: {
    background: 'var(--color-secondary-600)',
    color: 'var(--color-contrast-secondary-600)',
    borderColor: 'var(--color-secondary-700)',
    selectedBorderColor: 'var(--color-secondary-800)'
  },
  accent: {
    background: 'var(--color-accent-600)',
    color: 'var(--color-contrast-accent-600)',
    borderColor: 'var(--color-accent-700)',
    selectedBorderColor: 'var(--color-accent-800)'
  },
  dark: {
    background: 'var(--color-neutral-700)',
    color: 'var(--color-contrast-neutral-700)',
    borderColor: 'var(--color-neutral-800)',
    selectedBorderColor: 'var(--color-neutral-900)'
  },
  muted: {
    background: 'var(--color-neutral-400)',
    color: 'var(--color-contrast-neutral-400)',
    borderColor: 'var(--color-neutral-500)',
    selectedBorderColor: 'var(--color-neutral-600)'
  },
  success: {
    background: 'var(--color-success-600)',
    color: 'var(--color-contrast-success-600)',
    borderColor: 'var(--color-success-700)',
    selectedBorderColor: 'var(--color-success-800)'
  },
  warning: {
    background: 'var(--color-warning-600)',
    color: 'var(--color-contrast-warning-600)',
    borderColor: 'var(--color-warning-700)',
    selectedBorderColor: 'var(--color-warning-800)'
  },
  danger: {
    background: 'var(--color-danger-600)',
    color: 'var(--color-contrast-danger-600)',
    borderColor: 'var(--color-danger-700)',
    selectedBorderColor: 'var(--color-danger-800)'
  },
  info: {
    background: 'var(--color-info-600)',
    color: 'var(--color-contrast-info-600)',
    borderColor: 'var(--color-info-700)',
    selectedBorderColor: 'var(--color-info-800)'
  },
  default: {
    background: 'var(--color-surface-050)',
    color: 'var(--root-color)',
    borderColor: 'var(--color-neutral-200)',
    selectedBorderColor: 'var(--color-primary-500)'
  }
}

export const NODE_SIZES = {
  lg: { width: 400, padding: '14px 24px', fontSize: '0.9375rem' },
  md: { width: 200, padding: '10px 18px', fontSize: '0.8125rem' },
  sm: { width: 160, padding: '8px 14px', fontSize: '0.75rem' }
}

export function getVariantStyles (variantName, colorOverride) {
  const base = NODE_VARIANTS[variantName] || NODE_VARIANTS.default
  if (!colorOverride) return base
  return {
    ...base,
    background: colorOverride.background || base.background,
    color: colorOverride.text || base.color,
    borderColor: colorOverride.border || base.borderColor,
    selectedBorderColor: colorOverride.selectedBorder || colorOverride.border || base.selectedBorderColor
  }
}

export function getSizeStyles (sizeName) {
  return NODE_SIZES[sizeName] || NODE_SIZES.md
}
